import { Tag } from "@timeghost/web-api";
export interface DashboardConfig {
	auditData: {
		project: boolean;
		task: boolean;
		duration: boolean;
		mod: number;
		modTime: string;
		timezone: "keep" | "adjust";
		rulebreaks: boolean;
	};
	billable: number;
	clientData: string[];
	columns: string[];
	comegoType: string[];
	contingentUntilDate: string;
	createNew: boolean;
	displayName?: string;
	fromDateData: Date;
	groupData: string[];
	id?: string;

	personData: string[];
	projectData: string[];
	rangePreset: string;
	tabType: DashboardTabTypes;
	tagData: Tag[];
	taskData: string[];
	toDateData: Date;
}

export enum DashboardTabTypes {
	CONTINGENT = 2,
	WORKING_HOURS = 1,
	PROJECT_HOURS = 0,
}
